import React from 'react'
import DatePicker from '../../../molecules/DatePicker/DatePicker'
import styles from './DateSelectorPanel.module.scss'

interface DateSelectorPanelProps {
  label?: string
  onDateChange?: (date: Date) => void
}

const startDate = new Date(Date.now())

const DateSelectorPanel = ({ label, onDateChange }: DateSelectorPanelProps) => {
  return (
    <div className={styles.root}>
      <DatePicker inline label={label} date={startDate} onChange={onDateChange ?? (() => {})} />
    </div>
  )
}

export default DateSelectorPanel
